export default function IMContact() {
  return (
    <section className="py-20 px-8" style={{ background: "#0a1e3a" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-blue-300 tracking-widest uppercase mb-2 block">Contact Us</span>
          <h2 className="text-3xl font-bold text-white mb-3">联系招商团队</h2>
          <p className="text-blue-100/60 text-sm max-w-xl mx-auto">招商项目需结合您的区域产业深度定制，欢迎联系我们的专业顾问团队</p>
        </div>

        <div className="grid grid-cols-2 gap-12 max-w-5xl mx-auto">
          {/* Contact info */}
          <div> {/* Contact info */}
            <h3 className="text-white font-bold text-lg mb-6">关于我们</h3>
            <div className="space-y-5">
              {[
                { icon: "ri-phone-line", label: "服务热线", value: "400-660-9396" },
                { icon: "ri-map-pin-line", label: "地址", value: "北京市朝阳区安翔北里甲11号院北京创业大厦B座2层" },
                { icon: "ri-phone-line", label: "电话", value: "86-010-51286880" },
                { icon: "ri-printer-line", label: "传真", value: "86-010-51286880-801" },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-blue-400/10 border border-blue-400/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${item.icon} text-blue-300 text-lg`}></i>
                  </div>
                  <div>
                    <div className="text-blue-200/60 text-xs">{item.label}</div>
                    <div className="text-white text-sm font-medium mt-0.5">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact form */}
          <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
            <h3 className="text-white font-bold text-lg mb-6">申请试点方案</h3>
            <form onSubmit={(e) => e.preventDefault()} className="space-y-4">
              <div>
                <label className="text-blue-200/80 text-xs font-medium mb-1.5 block">您的姓名</label>
                <input
                  type="text"
                  placeholder="请输入姓名"
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-sm text-white placeholder-blue-200/40 focus:outline-none focus:border-blue-400/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-blue-200/80 text-xs font-medium mb-1.5 block">所在单位</label>
                <input
                  type="text"
                  placeholder="如：XX市经济开发区管委会"
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-sm text-white placeholder-blue-200/40 focus:outline-none focus:border-blue-400/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-blue-200/80 text-xs font-medium mb-1.5 block">联系电话</label>
                <input
                  type="text"
                  placeholder="请输入手机号"
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-sm text-white placeholder-blue-200/40 focus:outline-none focus:border-blue-400/60 transition-colors"
                />
              </div>
              <div>
                <label className="text-blue-200/80 text-xs font-medium mb-1.5 block">需求简述</label>
                <textarea
                  rows={3}
                  placeholder="请简要描述您的招商场景和需求..."
                  className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-sm text-white placeholder-blue-200/40 focus:outline-none focus:border-blue-400/60 transition-colors resize-none"
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-400 hover:bg-blue-300 text-[#0a1e3a] font-semibold py-3 rounded-xl text-sm transition-all cursor-pointer"
              >
                提交申请
              </button>
            </form>
          </div>
        </div>

        {/* Trust badges - below both columns */}
        <div className="grid grid-cols-4 gap-4 max-w-5xl mx-auto mt-10">
          {[
            { icon: "ri-shield-check-line", label: "国家电子政务认证", sub: "通过三级等保" },
            { icon: "ri-cloud-line", label: "支持私有化部署", sub: "数据不出内网" },
            { icon: "ri-team-line", label: "驻场实施服务", sub: "专项团队支持" },
            { icon: "ri-book-open-line", label: "完整培训体系", sub: "招商团队培训" },
          ].map((badge) => (
            <div key={badge.label} className="bg-white/5 rounded-xl px-4 py-3 border border-white/10 flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-blue-400/10 flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-blue-300 text-base`}></i>
              </div>
              <div>
                <div className="text-white text-xs font-medium">{badge.label}</div>
                <div className="text-blue-200/50 text-xs mt-0.5">{badge.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
